import { render, staticRenderFns } from "./NeedMyApproval.vue?vue&type=template&id=193945c2&scoped=true&"
import script from "./NeedMyApproval.vue?vue&type=script&lang=js&"
export * from "./NeedMyApproval.vue?vue&type=script&lang=js&"
import style0 from "./NeedMyApproval.vue?vue&type=style&index=0&id=193945c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193945c2",
  null
  
)

export default component.exports